<template>
  <div class="d-flex flex-column">
    <div class="d-flex justify-space-between align-end">
      <p>메시지 알리기</p>
      <v-checkbox :value="bool" @change="onChange" label="ON/OFF" dense hide-details></v-checkbox>
    </div>
    <!-- 디자인 시스템 AppInput (테마 자동). Enter = 표시하기 -->
    <AppInput v-model="input" placeholder="메시지 입력" @enter="onClickUpdate"></AppInput>
    <div class="d-flex justify-end" style="margin-top: 2px">
      <AppButton class="mr-1" variant="outline" size="xs" @click="onClickUpdate">표시하기</AppButton>
      <AppButton variant="outline" size="xs" @click="onClickDelay">10초 뒤 펑</AppButton>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      bool: false,
      input: null,
    };
  },
  methods: {
    onChange(bool) {
      this.bool = bool;
      this.$emit("checkbox", this.bool, this.input);
    },
    onClickUpdate() {
      this.bool = true;
      this.$emit("button", this.bool, this.input);
    },
    onClickDelay() {
      this.bool = true;
      this.$emit("delay-button", this.bool, `%10% ${this.input}`);
      setTimeout(() => {
        this.bool = false;
      }, 1000 * 10);
    },
  },
};
</script>

<style scoped>
p {
  margin: 0;
  padding: 0;
  font-size: 12px;
  font-weight: 500;
  color: #333; /* 라이트 기준 */
}
/* 다크 대응색 (.theme--dark는 v-app 조상 클래스 — scoped여도 매칭됨) */
.theme--dark p {
  color: #d1d5db;
}
</style>
